import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);

export const getCurrentReport = (reports, platformTime, hideWithoutLinks = true, isBbbCanBeUsedInSeparateLessons, isRemoveLinksToOfflineClasses) => {

    let currentReport = null;
    reports.forEach(report => {
        const startTime = dayjs(`${report.date_conference} ${report.start_time}`);
        let endTime = dayjs(`${report.date_conference} ${report.end_time}`);
        if (endTime.isBefore(startTime)) {
            endTime = endTime.add(1, 'day');
        }
        
        if (dayjs(platformTime).isBetween(startTime, endTime, null, '[]')) {
            currentReport = report;
        }
    });
    
    return currentReport;
}
